import USER_ONE_DATA from "./query.gql";
import { ScopeData } from "@/graphql/scopeData";

export interface UserOneVariables {
  userId: string;
}

export interface GroupData {
  id: string;
  name: string;
}

export interface UserData {
  id: string;
  name: string;
  loginId: string;
  email: string | null;
  scopes: ScopeData[];
  group: GroupData;
}

export interface UserOneData {
  user: UserData;
}

export { USER_ONE_DATA };
